import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { toggleValues } from '@department-of-veterans-affairs/platform-site-wide/selectors';
import FEATURE_FLAG_NAMES from '@department-of-veterans-affairs/platform-utilities/featureFlagNames';
import { APPEAL_TYPES } from '~/platform/shared/claims-appeals';

import TabItem from '../TabItem';

// Files tab is shown when the appeal is a supplemental claim AND the
// cst_supplemental_claims_evidence_upload flag is on. `appeal` is optional so
// existing callers that don't pass it (pre-Files-tab consumers) keep working
// with just Status and Issues.
export default function AppealsV2TabNav({ appeal }) {
  const supplementalClaimsUploadEnabled = useSelector(
    state =>
      toggleValues(state)[
        FEATURE_FLAG_NAMES.cstSupplementalClaimsEvidenceUpload
      ],
  );
  const isSupplementalClaim = appeal?.type === APPEAL_TYPES.supplementalClaim;
  const showFiles = isSupplementalClaim && !!supplementalClaimsUploadEnabled;

  return (
    <nav aria-label="Appeal">
      <ul className="tabs">
        <TabItem shortcut={1} id="v2status" tabpath="status" title="Status" />
        {showFiles && (
          <TabItem shortcut={2} id="v2files" tabpath="files" title="Files" />
        )}
        <TabItem
          shortcut={showFiles ? 3 : 2}
          id="v2detail"
          tabpath="detail"
          title="Issues"
        />
      </ul>
    </nav>
  );
}

AppealsV2TabNav.propTypes = {
  appeal: PropTypes.shape({
    type: PropTypes.string,
  }),
};
